// extracted by mini-css-extract-plugin
module.exports = {"nav":"TheNav_nav_2QiaH","spinAround":"TheNav_spinAround_3MDpc"};